var _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyLoss = function SvgMoneyLoss(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 49 52"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#money-loss_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.609,
    cy: 38.944,
    fill: "#fff",
    rx: 9.609,
    ry: 4.693
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M22.218 38.944c0 .7-.612 1.618-2.253 2.42-1.575.769-3.821 1.272-6.356 1.272s-4.781-.504-6.356-1.273C5.612 40.562 5 39.644 5 38.943s.612-1.617 2.253-2.419c1.575-.77 3.82-1.273 6.356-1.273s4.78.504 6.356 1.273c1.641.802 2.253 1.72 2.253 2.42Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#money-loss_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.609,
    cy: 34.027,
    fill: "#fff",
    rx: 9.609,
    ry: 4.693
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M22.218 34.027c0 .7-.612 1.618-2.253 2.42-1.575.769-3.821 1.273-6.356 1.273s-4.781-.504-6.356-1.273C5.612 35.645 5 34.727 5 34.027s.612-1.618 2.253-2.42c1.575-.769 3.82-1.273 6.356-1.273s4.78.504 6.356 1.274c1.641.801 2.253 1.719 2.253 2.42Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#money-loss_svg__c)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.609,
    cy: 29.111,
    fill: "#fff",
    rx: 9.609,
    ry: 4.693
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M22.218 29.11c0 .701-.612 1.619-2.253 2.42-1.575.77-3.821 1.273-6.356 1.273S8.828 32.3 7.253 31.53C5.612 30.73 5 29.811 5 29.11s.612-1.617 2.253-2.419c1.575-.77 3.82-1.273 6.356-1.273s4.78.504 6.356 1.273c1.641.802 2.253 1.72 2.253 2.42Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#money-loss_svg__d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.609,
    cy: 24.195,
    fill: "#fff",
    rx: 9.609,
    ry: 4.693
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M22.218 24.195c0 .7-.612 1.618-2.253 2.42-1.575.768-3.821 1.272-6.356 1.272s-4.781-.504-6.356-1.273C5.612 25.813 5 24.895 5 24.194s.612-1.617 2.253-2.419c1.575-.77 3.82-1.273 6.356-1.273s4.78.504 6.356 1.273c1.641.802 2.253 1.719 2.253 2.42Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#money-loss_svg__e)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.613,
    cy: 38.944,
    fill: "#fff",
    rx: 9.609,
    ry: 4.693
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M43.222 38.944c0 .7-.612 1.618-2.254 2.42-1.574.769-3.82 1.272-6.355 1.272s-4.781-.504-6.356-1.273c-1.641-.801-2.253-1.719-2.253-2.42s.612-1.617 2.253-2.419c1.575-.77 3.82-1.273 6.356-1.273s4.78.504 6.355 1.273c1.642.802 2.254 1.72 2.254 2.42Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#money-loss_svg__f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.613,
    cy: 34.027,
    fill: "#fff",
    rx: 9.609,
    ry: 4.693
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M43.222 34.027c0 .7-.612 1.618-2.254 2.42-1.574.769-3.82 1.273-6.355 1.273s-4.781-.504-6.356-1.273c-1.641-.802-2.253-1.72-2.253-2.42s.612-1.618 2.253-2.42c1.575-.769 3.82-1.273 6.356-1.273s4.78.504 6.355 1.274c1.642.801 2.254 1.719 2.254 2.42Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#money-loss_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M40.103 10.666v12.799m0 0H27.304m12.8 0L23.037 6.399"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "money-loss_svg__a",
    width: 27.217,
    height: 17.385,
    x: 0,
    y: 34.251,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_227_104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_227_104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "money-loss_svg__b",
    width: 27.217,
    height: 17.385,
    x: 0,
    y: 29.334,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_227_104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_227_104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "money-loss_svg__c",
    width: 27.217,
    height: 17.385,
    x: 0,
    y: 24.418,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_227_104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_227_104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "money-loss_svg__d",
    width: 27.217,
    height: 17.385,
    x: 0,
    y: 19.502,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_227_104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_227_104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "money-loss_svg__e",
    width: 27.217,
    height: 17.385,
    x: 21.004,
    y: 34.251,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_227_104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_227_104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "money-loss_svg__f",
    width: 27.217,
    height: 17.385,
    x: 21.004,
    y: 29.334,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_227_104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_227_104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "money-loss_svg__g",
    width: 26.773,
    height: 26.773,
    x: 18.33,
    y: 5.692,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_227_104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_227_104",
    result: "shape"
  })))));
};
export default SvgMoneyLoss;